<div class="d-flex flex-column busy-overlay-parent" [ngClass]="isSaving?'disabled':''">    

    <div *ngIf="isSaving" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Processing...
    </div>
    <form #azimuthForm="ngForm" class="p-0 m-0">
    <table class="azimuth-table table table-striped table-bordered table-sm mb-1 w-100">
        <thead>
        <tr>
            <th colspan="2">
                <div class="d-flex flex-row justify-content-between">
                    <div class="text-center">External Wall Azimuths</div>
                    <button *ngIf="!isEditing" (click)="onEdit()" class="edit-azimuth-btn btn btn-secondary"><i class="fa fa-edit"></i>&nbsp;Edit</button>
                </div>
            </th>
        </tr>
        </thead>
        <tbody *ngIf="scoutPath">
            <tr>
                <th class="text-nowrap text-right">Start Point</th>
                <td>
                    <div class="w-100 d-flex flex-row">
                        <select *ngIf="isEditing" #azimuthCornerSelect name="azimuthCornerSelect" 
                            (change)="onAzimuthCornerChanged($event)" 
                            [(ngModel)]="azimuthCorner" [ngModelOptions]="{standalone: true}">
                            <option *ngFor="let direction of directions" [ngValue]="direction">{{direction}}</option>
                        </select>
                        <div *ngIf="!isEditing" class="align-self-end">
                            <ng-container [ngSwitch]="scoutPath.azimuthCorner">
                                <ng-container *ngSwitchCase="'N'">North</ng-container>
                                <ng-container *ngSwitchCase="'NE'">North East</ng-container>
                                <ng-container *ngSwitchCase="'E'">East</ng-container>
                                <ng-container *ngSwitchCase="'SE'">South East</ng-container>
                                <ng-container *ngSwitchCase="'S'">South</ng-container>
                                <ng-container *ngSwitchCase="'SW'">South West</ng-container>
                                <ng-container *ngSwitchCase="'W'">West</ng-container>
                                <ng-container *ngSwitchCase="'NW'">North West</ng-container>
                            </ng-container>
                        </div>
                        <div class="align-self-end">
                            <ng-container [ngSwitch]="isEditing?azimuthCorner:scoutPath.azimuthCorner">
                                <ng-container *ngSwitchCase="'N'"><i class="px-2 fa fa-chevron-up"></i></ng-container>
                                <ng-container *ngSwitchCase="'NE'"><i class="px-2 fa fa-chevron-up azimuth-rotate-45"></i></ng-container>
                                <ng-container *ngSwitchCase="'E'"><i class="px-2 fa fa-chevron-right"></i></ng-container>
                                <ng-container *ngSwitchCase="'SE'"><i class="px-2 fa fa-chevron-right azimuth-rotate-45"></i></ng-container>
                                <ng-container *ngSwitchCase="'S'"><i class="px-2 fa fa-chevron-down"></i></ng-container>
                                <ng-container *ngSwitchCase="'SW'"><i class="px-2 fa fa-chevron-down azimuth-rotate-45"></i></ng-container>
                                <ng-container *ngSwitchCase="'W'"><i class="px-2 fa fa-chevron-left"></i></ng-container>
                                <ng-container *ngSwitchCase="'NW'"><i class="px-2 fa fa-chevron-left azimuth-rotate-45"></i></ng-container>
                            </ng-container>
                        </div>
                        <div class="pl-1 font-italic small text-muted align-self-end">
                            {{scoutPath.azimuthCorner?'Building Corner':'--'}}
                        </div>
                    </div>
                </td>
            </tr>
            <tr>
                <th class="text-nowrap text-right">Azimuth 1</th>
                <td class="text-nowrap">
                    <ng-container *ngIf="azimuthCorner">
                    {{azimuth1Directions[0]}}<i class="fa fa-long-arrow-alt-right"></i>{{azimuth1Directions[1]}}
                    (<ng-container *ngIf="!isEditing">{{azimuth1Angle}}</ng-container><ng-container *ngIf="isEditing">
                    <input name="azimuth1AngleInput" type='number' style="width: 40px;"
                    [(ngModel)]="azimuth1Angle" #azimuth1AngleInput="ngModel" [min]="0" [lt]="360"
                    [ngClass]="{ 'invalid-input': azimuth1AngleInput.invalid && (azimuth1AngleInput.dirty || azimuth1AngleInput.touched)}"
                    ></ng-container>&deg;)
                    <i class="px-1 fa fa-long-arrow-alt-up align-self-center" 
                    [ngStyle]="{transform: 'rotate('+azimuth1Angle+'deg)'}"></i>
                    </ng-container>
                </td>
            </tr>
            <tr>
                <th class="text-nowrap text-right">Azimuth 2</th>
                <td class="text-nowrap">
                    <ng-container *ngIf="azimuthCorner">
                    {{azimuth2Directions[0]}}<i class="fa fa-long-arrow-alt-right"></i>{{azimuth2Directions[1]}}
                    (<ng-container *ngIf="!isEditing">{{azimuth2Angle}}</ng-container><ng-container *ngIf="isEditing">
                        <input name="azimuth2AngleInput" type='number' style="width: 40px;"
                        [(ngModel)]="azimuth2Angle" #azimuth2AngleInput="ngModel" [min]="0" [lt]="360"
                        [ngClass]="{ 'invalid-input': azimuth2AngleInput.invalid && (azimuth2AngleInput.dirty || azimuth2AngleInput.touched)}"
                        ></ng-container>&deg;)
                    <i class="px-1 fa fa-long-arrow-alt-up align-self-center" 
                    [ngStyle]="{transform: 'rotate('+azimuth2Angle+'deg)'}"></i>
                    </ng-container>
                </td>
            </tr>
            <tr app-addl-azimuth *ngFor="let azimuth of addlAzimuths;" 
                [azimuths]="addlAzimuths"
                [azimuth]="azimuth"
                [isEditing]="isEditing">
            </tr>
            <tr *ngIf="isEditing">
                <td colspan="2">
                    <div class="d-flex justify-content-between">
                    <div class="p-2">
                        <button (click)="onAdd()" class="btn btn-secondary btn-sm small"><i class="fa fa-plus-square"></i> Add</button>
                    </div>
                    <div class="d-flex flex-row justify-content-end p-2">
                        <button (click)="onSave()" [disabled]="!isModified()||azimuthForm.invalid" class="btn btn-secondary btn-sm small mr-2">Save</button>
                        <button (click)="onCancel()" class="btn btn-secondary btn-sm small">Cancel</button>
                    </div>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
    </form>
</div>

                

